import React from 'react';
import s from './Pagination.module.less';
import { InputNumber, Tooltip, Select as AntSelect } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Identifiable, Select, Button } from '@custis/common';
import classNames from 'classnames';
import { PaginationProps } from '../../models';

interface Props<TItem extends Identifiable> extends PaginationProps<TItem> {
  className?: string;
}

export const Pagination = <TItem extends Identifiable>({
  gotoPage,
  nextPage,
  previousPage,
  canPreviousPage,
  canNextPage,
  pageCount,
  setPageSize,
  pageIndex,
  pageSize,
  className,
}: Props<TItem>) => {
  return (
    <div className={classNames(s.PaginationButtons, className)}>
      {canPreviousPage && (
        <Tooltip title={'Назад'}>
          <Button
            size={'small'}
            onClick={previousPage}
            disabled={!canPreviousPage}
            className={classNames(s.Button, s.LeftButton)}
          >
            <LeftOutlined />
          </Button>
        </Tooltip>
      )}{' '}
      <span className={s.Font}>
        {' '}
        <InputNumber
          defaultValue={pageIndex + 1}
          value={pageIndex + 1}
          min={1}
          size={'small'}
          maxLength={6}
          max={pageCount}
          onChange={(value) => {
            if (String(value).length <= 6 && Number(value) <= pageCount) {
              const page = value ? Number(value) - 1 : 0;
              gotoPage(page);
            }
          }}
          style={{ width: 60 }}
          className={classNames(s.Font, s.Number)}
        />{' '}
        из {pageCount}{' '}
      </span>{' '}
      {canNextPage && (
        <Tooltip title={'Вперед'}>
          <Button
            size={'small'}
            onClick={nextPage}
            disabled={!canNextPage}
            className={classNames(s.Button, s.RightButton)}
          >
            <RightOutlined />
          </Button>
        </Tooltip>
      )}{' '}
      <Select
        value={pageSize}
        size={'small'}
        className={classNames(s.Select, s.Font)}
        onChange={(e) => {
          setPageSize(Number(e));
        }}
      >
        {[10, 20, 50, 100, 200].map((pageSize) => (
          <AntSelect.Option key={pageSize} value={pageSize} className={s.Font}>
            {pageSize} / стр.
          </AntSelect.Option>
        ))}
      </Select>
    </div>
  );
};
